import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const STATUS_LABEL = {
  en_attente_paiement: "En attente de paiement",
  paiement_declare: "Paiement à vérifier",
  paye: "Payée",
  expedie: "Expédiée / livrée",
  annule: "Annulée",
};

export const loginWithGoogle = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/compte";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const euro = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(Number(n) || 0);

export const TYPE_LABEL = { physique: "Objet", numerique: "Numérique", affiliation: "Partenaire" };
export const COLLECTION_LABEL = {
  bureau: "Bureau",
  cuisine: "Cuisine",
  maisonjardin: "Maison & Jardin",
  bazar: "Bazar",
  assise: "Assise",
  lumiere: "Lumière",
  rangement: "Rangement",
  audio: "Audio",
  tech: "Tech",
  bienetre: "Bien-être",
  digital: "Outils numériques",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
